import filters from "../services/filters";
import utils from "../services/utils";
import store from "../store";
import {ENUMS} from "../services/enums";
import {MODELS} from "../services/models";

const state = () => ({
  currentTab: "all",
  filters: {
    // Make sure to update resetFilters
    inbox: {
      users: [],
      campaigns: [],
      phoneNumbers: [],
      sources: null,
    },
    preset: {
      users: [],
      campaigns: [],
      phoneNumbers: [],
      sources: null,
    }
  },
});

const getters = {
  filters: (state) => (filterObject) => {
    return state.filters[filterObject]
  },
  leadItems(state, getters, rootState) {
    let leadItems = [...rootState.market.inboxLeadsItemLite];

    // Filter
    leadItems = filters.bySource(leadItems, state.filters.inbox.sources);
    leadItems = filters.byUsers(leadItems, state.filters.inbox.users);
    leadItems = filters.byMultipleCampaigns(leadItems, state.filters.inbox.campaigns);
    leadItems = filters.byCreatedMultiplePhoneNumbers(leadItems, state.filters.inbox.phoneNumbers);

    // Setup sorting
    leadItems.forEach(lead => {
      // This is done because of inboundComms complexity
      lead.sortDate = lead.created_at;
    })

    // Sort
    leadItems.sort((a,b) => new Date(b.sortDate) - new Date(a.sortDate));

    return leadItems;
  },
  inboundComms(state, getters, rootState) {
    return [...rootState.market.inboxInboundCommsItemLiteComms];
  },
  commItems(state, getters, rootState, rootGetters) {
    let commItems = [...rootState.market.inboxInboundCommsItemLite];

    commItems.forEach(comm => {
      comm.communicationLogs = getters.inboundComms.filter(inboundComm => comm.id === inboundComm.contact_id);
    });

    // Filter
    const integrationPhoneNumbers = rootGetters.integrationPhoneNumbers
    commItems = commItems.filter(item => {
      const latestComm = item.communicationLogs[0]
      if (state.filters.inbox.phoneNumbers.length !== 0 && latestComm.type !== ENUMS.CommunicationTypeEnum.Email) {
        const phoneNumber = integrationPhoneNumbers.find(phoneNumber => {
          if (latestComm.integration_phone_number_id) {
            return phoneNumber.id === latestComm.integration_phone_number_id
          }

          return phoneNumber.number === latestComm.tracking_number
        })

        return !!state.filters.inbox.phoneNumbers.includes(phoneNumber.id)
      }

      // If there is not a primary record then don't filter
      if(!item.primaryRecord) {
        return true;
      }

      //Must clone, so as not to mutate the underling object
      item = utils.clone(item);


      // Need to turn single record into array for filters to work
      let recordsArray = [item.primaryRecord];

      recordsArray = filters.byUsers(recordsArray, state.filters.inbox.users);
      recordsArray = filters.byMultipleCampaigns(recordsArray, state.filters.inbox.campaigns);

      // Only return item if not filtered out
      if (recordsArray.length > 0) {
        return true;
      }
    });

    // Setup sorting
    commItems.forEach(comm => {
      // commItems are based off contacts, so we need to get the proper comm log to use for date sorting
      if (comm.communicationLogs.length !== 0) {
        comm.sortDate = comm.communicationLogs[0].created_at;
      }
    })

    // Sort
    commItems.sort((a,b) => new Date(b.sortDate) - new Date(a.sortDate));

    return commItems;
  },
  items(state, getters) {
    let allItems = [
      ...getters.commItems,
      ...getters.leadItems,
    ];

    return allItems.sort((a, b) => new Date(b.sortDate) - new Date(a.sortDate));
  },
  itemsCount(state, getters) {
    return getters.items.length;
  },
  filterCount(state, getters) {
    let count = 0
    for (let filterKey in getters.filters('inbox')) {
      const filterValue = getters.filters('inbox')[filterKey]
      if (filterValue && filterValue.length !== 0) count += 1
    }

    return count
  },
};

const mutations = {
  setOneFilter(state, [filterObject, filter, value]) {
    state.filters[filterObject][filter] = value;
  },
  setUserFilters(state, filters) {
    // make sure this match the filters declared on state
    // state.filters = filters
  },
  resetFilters(state, filterObject) {
    // Make sure to update state default
    state.filters[filterObject] = {
      users: [],
      campaigns: [],
      phoneNumbers: [],
      sources: null,
    };
  },
  setTab(state, tab) {
    state.currentTab = tab;
  },
};

const actions = {
  setup({commit, state, getters, rootGetters}) {
    const defaultPreset = rootGetters.inboxTableConfigurations.find(preset => preset.id === rootGetters.authUser.default_inbox_preset_id)
    if (!defaultPreset) {
      commit("resetFilters", "inbox")
    } else {
      for (const [filterKey, filterValue] of Object.entries(getters.filters("inbox"))) {
        const filterPresetValue = defaultPreset.filters[filterKey]
        if (filterPresetValue) {
          commit("setOneFilter", ["inbox", filterKey, filterPresetValue])
        }
      }
    }
  },
};

const InboxStore = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export default InboxStore;
